import apiClient from "@/axios";

export const getAppHistory = async (appId, countryId) => {
  const response = await apiClient.post("/user/app/histories", {
    appId: appId,
    countryId: countryId,
  });
  return response;
};

